import { attachmentsApi } from '../api/attachments'
import type { InlineMediaDraft } from './issueDescription'
import {
  filterReferencedInlineMedia,
  replaceInlineMediaPlaceholders,
} from './issueDescription'

export async function finalizeInlineMediaForExistingIssue(options: {
  issueId: string
  content?: string
  inlineMedia?: InlineMediaDraft[]
}) {
  const usedInlineMedia = filterReferencedInlineMedia(options.content || '', options.inlineMedia || [])

  const replacements = await Promise.all(
    usedInlineMedia.map(async (draft) => {
      const uploaded = await attachmentsApi.uploadAttachment(options.issueId, draft.file)
      return {
        draft,
        fileUrl: uploaded.data.data.fileUrl,
        filename: uploaded.data.data.filename,
      }
    })
  )

  return replaceInlineMediaPlaceholders(options.content, replacements)
}

export async function finalizeIssueAttachmentsAndInlineMedia(options: {
  issueId: string
  description?: string
  attachments?: File[]
  inlineMedia?: InlineMediaDraft[]
}) {
  const finalDescription = await finalizeInlineMediaForExistingIssue({
    issueId: options.issueId,
    content: options.description,
    inlineMedia: options.inlineMedia,
  })

  if (options.attachments?.length) {
    await Promise.all(options.attachments.map((file) => attachmentsApi.uploadAttachment(options.issueId, file)))
  }

  return finalDescription
}
